import { events, on } from 'elc-service-bus';
import { PowerReviewsInitializedUseCase } from '../internal/use-cases/PowerReviewsInitializedUseCase';
import { ReadReviewsClickedUseCase } from '../internal/use-cases/ReadReviewsClickedUseCase';
import { WriteReviewClickedUseCase } from '../internal/use-cases/WriteReviewClickedUseCase';
import { ProductFullLoadedUseCase } from '../internal/use-cases/ProductFullLoadedUseCase';

interface IProductFullLoaded {
    productId: string;
    skuId: string;
}
export class ServiceBusController {
    @on(events.SPP_POWER_REVIEWS_INIT)
    public powerReviewsInitialized = async (productId: string) => {
        const powerReviewsInitializedUseCase = new PowerReviewsInitializedUseCase(productId);
        await powerReviewsInitializedUseCase.execute();
    };

    @on(events.READ_REVIEWS_LINK_CLICKED)
    public readReviewsLinkClicked = () => {
        const readReviewsLinkClickedUseCase = new ReadReviewsClickedUseCase();
        readReviewsLinkClickedUseCase.execute();
    };

    @on(events.WRITE_REVIEWS_LINK_CLICKED)
    public writeReviewsLinkClicked = () => {
        const writeReviewsLinkClickedUseCase = new WriteReviewClickedUseCase();
        writeReviewsLinkClickedUseCase.execute();
    };

    @on(events.PRODUCT_FULL_LOADED)
    public productFullLoaded = ({ productId }: IProductFullLoaded) => {
        const productFullLoadedUseCase = new ProductFullLoadedUseCase(productId);
        productFullLoadedUseCase.execute();
    };
}
